import { render, staticRenderFns } from "./assign-cards.vue?vue&type=template&id=23b954f4&"
import script from "./assign-cards.vue?vue&type=script&lang=js&"
export * from "./assign-cards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports